/**
 * Branding tenant (Q102) : nom et logo de l'entreprise sur ce que voient SES
 * clients (portails, page QR, propositions). Les valeurs viennent de
 * `companies.branding` et sont RE-VALIDÉES ici avant d'atteindre un attribut
 * `src` (défense en profondeur : le serveur les nettoie déjà).
 *
 * Décision du 12/10/2026 : l'application interne garde l'identité MyEquip
 * (logo, couleurs, titre, favicon). Personnaliser ses documents ne change plus
 * la barre de navigation ni les couleurs de l'outil des équipes.
 */
import { PLATFORM_BRANDING, sanitizeTenantBranding, type TenantBranding } from '@myequip/shared';
import { apiAssetUrl } from './api.js';

/** Nom affiché : celui du tenant s'il en a un, sinon le nom du produit. */
export function brandName(branding: TenantBranding | null | undefined): string {
  return sanitizeTenantBranding(branding).displayName ?? PLATFORM_BRANDING.productName;
}

/** Logo du tenant (URL sûre) ou `undefined` → le logotype par défaut est utilisé. */
export function brandLogoUrl(branding: TenantBranding | null | undefined): string | undefined {
  const safe = sanitizeTenantBranding(branding);
  if (safe.logoUrl) return safe.logoUrl;
  return safe.logoFileId
    ? apiAssetUrl(`/public/company-logo/${encodeURIComponent(safe.logoFileId)}`)
    : undefined;
}
